import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const IncreaseLowRiskLimitModal = (props) => {
    const { notNowButton, continueButton, increaseLimitPurpleTitle, increaseLimitTitle, increaseLimitSubTitle, increaseLimitSubCountryName } =
        usePageMessages();
    const { increaseLimitUrl } = useExtra();

    const text = (
        <>
            <span>{increaseLimitPurpleTitle}</span>
            <br />
            {increaseLimitTitle}
        </>
    );

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="bank-building-card-thin"
                iconColor="primary"
                topButtonCaption={notNowButton}
                topButtonType={'link'}
                topButtonLink={props.notNowLink}
                topButtonOnClick={(e) => {
                    if (!props.notNowLink) {
                        e?.preventDefault();
                        props.modalRef?.current?.close();
                    }
                }}
                primaryButtonCaption={continueButton}
                primaryButtonType={'link'}
                primaryButtonLink={increaseLimitUrl}
                headerText={text}
                secondaryText={resolveArguments(increaseLimitSubTitle, [increaseLimitSubCountryName])}
                primaryButtonOnClick={() => {
                    props.toggleSpinner(true);
                }}
            />
        </ModalComponent>
    );
};
IncreaseLowRiskLimitModal.propTypes = {
    modalRef: PropTypes.object.isRequired,
    notNowLink: PropTypes.string,
};

export default connect(null, { toggleSpinner })(IncreaseLowRiskLimitModal);
